<template>
    <div>
        <div class="food__edit__header">
            <slot name="header"></slot>
            <loading-button v-show="showSaveBtn" :loading="isLoading" :status="status" @click="storeOrUpdate"><i
                    class="fa fa-save"></i> Zapisz do mojej bazy
            </loading-button>
        </div>

        <div class="row">
            <div class="col-xs-12">
              <v-alert type="error" :value="!foodNameValid">
                Nazwa dania jest wymagana.
              </v-alert>
            </div>
        </div>
        <div class="row mb-20" v-if="food.isMultiPortionFood() || mode === 'create'">
            <div class="col-xs-2 text-left">
                <label class="control-label" for="food-name">Nazwa</label>
            </div>
            <div class="col-xs-5">
                <input class="form-control form-control-xs"
                       placeholder="Nazwa dania"
                       id="food-name"
                       v-bind:value="food.name"
                       v-on:input="getFoodNameOnInputListener(food, $event)"
                >
            </div>
            <div class="col-xs-3 text-right">
                <label class="control-label" for="portions">Przepis na porcji</label>
            </div>
            <div class="col-xs-2">
                <input type="number"
                       class="form-control form-control-xs"
                       id="portions"
                       :min="getPortionsMin(food)"
                       :step="getPortionsStep(food)"
                       v-bind:value="getPortionsBind(food)"
                       v-on:input="getPortionsOnInputListener(food, $event)"
                       v-on:change="getPortionsOnChangeListener(food, $event)"
                >
            </div>
            <slot name="multi_portion_food_portion_amount"></slot>
        </div>
        <div v-else>
            <div class="col-xs-2 text-left">
                <label class="control-label" for="food-name">Nazwa</label>
            </div>
            <div class="col-xs-7">
                <input class="form-control form-control-xs"
                       placeholder="Nazwa dania"
                       id="food-name"
                       v-bind:value="food.name"
                       v-on:input="getFoodNameOnInputListener(food, $event)"
                >
            </div>
            <div class="col-xs-1 text-right">
                <label class="control-label" for="portions">Ilość</label>
            </div>
            <div class="col-xs-2">
                <input type="number"
                       class="form-control form-control-xs"
                       id="portions"
                       :min="getPortionsMin(food)"
                       :step="getPortionsStep(food)"
                       v-bind:value="getPortionsBind(food)"
                       v-on:input="getPortionsOnInputListener(food, $event)"
                       v-on:change="getPortionsOnChangeListener(food, $event)"
                >
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <label class="control-label">Składniki</label>
                <table class="table table-bordered table-condensed products-table">
                  <tr>
                    <th></th>
                    <th class="full-width">Nazwa</th>
                    <th class="text-center number__select__col">Ilość</th>
                    <th class="text-center nutrient__col">Kcal</th>
                    <th class="text-center nutrient__col">W</th>
                    <th class="text-center nutrient__col">B</th>
                    <th class="text-center nutrient__col">T</th>
                    <th class="text-center nutrient__col">Bł</th>
                    <th style="min-width: 40px;"></th>
                  </tr>
                  <tbody tag="tbody"
                         :list="food.products"
                         group='food_products'
                         :draggable="`.food_product`"
                         handle=".food_product_drag_icon"
                         is="draggable">
                    <tr class="food_product" :key="product.id" v-for="product in food.products">
                      <td class="product-sort">
                        <v-icon class="food_product_drag_icon" small>swap_vert</v-icon>
                      </td>
                      <td>
                        {{ product.name }}

                        <span id="unlike-product" class="label label-warning"
                              :class="{hidden: !product.disliked}"
                              v-tooltip="'Produkt jest nielubiany przez pacjenta'"><i
                            class="fa fa-thumbs-down"></i></span>

                        <span id="allergy-product" class="label label-danger"
                              :class="{hidden: !product.allergen}"
                              v-tooltip="'Produkt jest alergiczny dla pacjenta'">
                            <i class="fa fa-ban"></i>
                        </span>
                      </td>
                      <td>
                        <div class="number__select">
                          <input type=number
                                 min="1"
                                 class="form-control form-control-xs"
                                 v-model="product.portion.amount"
                                 v-on:input="getFoodProductPortionAmountListener(product, food)"
                          >
                          <select class="form-control form-control-xs"
                                  v-model="product.portion.weight"
                                  v-on:input="getFoodProductPortionWeightListener(product, food)"
                          >
                            <option v-for="weight in product.weight" v-bind:value="weight">
                              {{ weight.unit }}
                              <span v-if="weight.amount !== 1">
                                        ({{ weight.amount }}g)
                                        </span>
                            </option>
                          </select>
                        </div>
                      </td>
                      <td class="text-center">
                        {{ product.energyInPortion.amount | round }}
                      </td>
                      <td class="text-center">
                        {{ product.sumNutrientById(CARBO) | round }}
                      </td>
                      <td class="text-center">
                        {{ product.sumNutrientById(PROTEIN) | round }}
                      </td>
                      <td class="text-center">
                        {{ product.sumNutrientById(FATS) | round }}
                      </td>

                      <td class="text-center">
                        {{ product.sumNutrientById(FIBER) | round }}
                      </td>
                      <td class="text-center">
                                     <span title="Zamień produkt"
                                           v-if="hasPermission('creator_products_replace') && mode === 'edit' && hideReplacing === false"
                                           @click="replaceProduct(product)"
                                           role="button">
                            <i class="fa fa-refresh text-green"></i>
                          </span>
                        <span title="Usuń składnik" @click="confirmRemove(product.id)"
                              v-if="food.products.length > 1" role="button">
                                <i class="fa fa-times text-red"></i>
                            </span>
                      </td>
                    </tr>
                  <tr v-if="food.isMultiPortionFood()">
                    <th colspan="3" class="text-right">
                      <span>Wartości na {{
                          food.portion.amount
                        }} {{ polishPlurals('porcję', 'porcje', 'porcji', food.portion.amount) }}</span>
                      <i class="fa fa-question-circle"
                         v-tooltip="'Pogrubione wartości odżywcze są podane na wybraną ilość porcji w tym daniu'"></i>
                    </th>
                    <th class="text-center">
                      {{ food.calculateEnergy(false).amount | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(CARBO, true) | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(PROTEIN, true) | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(FATS, true) | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(FIBER, true) | round }}
                    </th>
                  </tr>
                  <tr v-else>
                    <th colspan="3"></th>
                    <th class="text-center">
                      {{ food.calculateEnergy(true).amount | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(CARBO, false) | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(PROTEIN, false) | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(FATS, false) | round }}
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(FIBER, false) | round }}
                    </th>
                  </tr>
                  <tr>
                    <th colspan="3" class="text-right">
                      WW
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(WW, food.isMultiPortionFood()) | round }}
                    </th>
                    <th colspan="4"></th>
                  </tr>
                  <tr>
                    <th colspan="3" class="text-right">
                      WBT
                    </th>
                    <th class="text-center">
                      {{ food.sumNutrientById(WBT, food.isMultiPortionFood()) | round }}
                    </th>
                    <th colspan="4"></th>
                  </tr>
                  <tr>
                    <th colspan="3" class="text-right">
                      Ładunek glikemiczny
                    </th>
                    <th class="text-center">
                      {{ food.calculateGlicemicLoad(food.isMultiPortionFood()) | round }}
                    </th>
                    <th colspan="4"></th>
                  </tr>
                  <tr>
                    <th colspan="3" class="text-right">
                      Indeks glikemiczny
                    </th>
                    <th class="text-center">
                      {{ food.calculateGlicemicIndex(food.isMultiPortionFood()) | round }}
                    </th>
                    <th colspan="4"></th>
                  </tr>
                  <tr>
                    <th colspan="3" class="text-right">
                      <a @click="showModal({
                        component: 'food-summary',
                        data: {
                          food: food
                        },
                        options: {large: true}
                      })" role="button" title="Pozostałe wartości odżywcze">Pozostałe</a>
                    </th>
                    <th colspan="5"></th>
                  </tr>
                  </tbody>
                </table>
                <div class="row mb-20">
                    <div class="col-xs-12">
                        <div v-if="selected">
                            <table class="table table-bordered table-condensed">
                                <tbody>
                                <tr>
                                    <th class="full-width">Nazwa</th>
                                    <th class="text-center number__select__col">Ilość</th>
                                    <th class="text-center nutrient__col" title="Energia">Kcal</th>
                                    <th class="text-center nutrient__col" title="Węglowodany">W</th>
                                    <th class="text-center nutrient__col" title="Białko">B</th>
                                    <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                                    <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                                    <th style="width: 40px;"></th>
                                </tr>
                                <tr>
                                    <td>

                                        {{selected.name}}

                                        <span id="unlike-selected" class="label label-warning"
                                              :class="{hidden: !selected.disliked}"
                                              v-tooltip="'Produkt jest nielubiany przez pacjenta'">
                                    <i class="fa fa-thumbs-down"></i>
                                </span>
                                        <span id="allergy-selected" class="label label-danger"
                                              :class="{hidden: !selected.allergen}"
                                              v-tooltip="'Produkt jest alergiczny dla pacjenta'">
                                    <i class="fa fa-ban"></i></span>
                                    </td>
                                    <td>
                                        <div class="number__select">
                                            <input type="number" min="1" required v-model="selected.portion.amount"
                                                   class="form-control form-control-xs">
                                            <select v-model="selected.portion.weight"
                                                    class="form-control form-control-xs">
                                                <option v-for="weight in selected.weight" v-bind:value="weight">
                                                    {{weight.unit}}
                                                    <span v-if="weight.amount !== 1">
                                            ({{weight.amount}}g)
                                            </span>
                                                </option>
                                            </select>
                                        </div>
                                    </td>

                                    <td class="text-center">
                                        {{selected.energyInPortion.amount | round}}
                                    </td>
                                    <td class="text-center">
                                        {{selected.sumNutrientById(CARBO) | round}}
                                    </td>
                                    <td class="text-center">
                                        {{selected.sumNutrientById(PROTEIN) | round}}
                                    </td>
                                    <td class="text-center">
                                        {{selected.sumNutrientById(FATS) | round}}
                                    </td>
                                    <td class="text-center">
                                        {{selected.sumNutrientById(FIBER) | round }}
                                    </td>

                                    <td class="text-center">
                                <span @click="addProduct(selected)" role="button" title="Dodaj produkt"
                                      class="btn btn-xs btn-success">
                                    <i class="fa fa-plus"></i>
                                </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <search-select placeholder="Dodaj produkt"
                                       :endpoint="configuration.search.product"
                                       ref="productSelect"
                                       @item-selected="displayProduct">
                        </search-select>
                        <v-alert type="error" :value="!foodHasProducts">
                          Wymagany jest przynajmniej jeden produkt
                        </v-alert>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-10">
            <div class="col-xs-12">
                <label class="control-label">Przygotowanie</label>
                <textarea name="recipe"
                          class="form-control editor"
                          rows="4"
                          placeholder="Opis przygotowania..."
                          v-bind:value="food.recipe"
                          v-on:input="getFoodRecipeOnInputListener(food, $event)"
                >
                </textarea>
                <v-alert type="success" :value="productReplaced">
                  Produkt został zamieniony. Sprawdź czy opis przygotowania posiłku jest poprawny.
                </v-alert>
                <v-alert type="error" :value="!foodRecipeValid">
                  Opis przygotowania jest wymagany
                </v-alert>
            </div>
        </div>
        <div class="panel box box-default">
            <div class="box-header with-border">
                <a data-toggle="collapse" href="#tagsSection" class="collapsed"
                   aria-expanded="false">
                    <i class="fa fa-chevron-down"></i> Tagi
                </a>
            </div>

            <div id="tagsSection" class="panel-collapse collapse" aria-expanded="false">
                <div class="box-body">
                    <div class="row mb-10">
                        <div class="col-xs-6">
                            <label class="control-label">Tagi</label>
                            <vue-select :options="configuration.tags"
                                        placeholder="Wybierz tagi..."
                                        multiple
                                        clearable
                                        v-model="food.tags"
                                        v-on:change="getFoodTagsOnChangeListener(food)"
                            ></vue-select>
                        </div>
                        <div class="col-xs-6">
                            <label class="control-label">Dieta</label>
                            <vue-select :options="configuration.diets"
                                        placeholder="Wybierz diety..."
                                        multiple
                                        v-model="food.diets"
                                        v-on:change="getFoodDietsOnChangeListener(food)"
                            ></vue-select>
                        </div>
                    </div>
                    <div class="row mb-10">
                        <div class="col-xs-6">
                            <label class="control-label">Posiłek</label>
                            <vue-select :options="configuration.meals"
                                        placeholder="Wybierz posiłki..."
                                        multiple
                                        v-model="food.meals"
                                        v-on:change="getFoodMealsOnChangeListener(food)"
                            ></vue-select>
                        </div>
                        <div class="col-xs-6">
                            <label class="control-label">Wyposażenie</label>
                            <vue-select :options="configuration.equipments"
                                        placeholder="Wybierz wyposażenie..."
                                        multiple
                                        v-model="food.equipments"
                                        v-on:change="getFoodEquipmentsOnChangeListener(food)"
                            ></vue-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="foodPortions.length > 0" class="row">
            <div class="col-xs-8 col-xs-offset-2">
                <div class="text-center text-bold">
                    <p>Porcje</p>
                </div>
            </div>
        </div>
        <table class="table table-bordered table-condensed manage-meals-products-and-foods-table"
               v-if="foodPortions.length > 0">
            <tbody>
            <tr>
                <th class="text-center">Dzień</th>
                <th class="text-center">Posiłek</th>
                <th class="text-center number__select__col">Porcje</th>
                <th class="text-center nutrient__col" title="Energia">Kcal</th>
                <th class="text-center nutrient__col" title="Węglowodany">W</th>
                <th class="text-center nutrient__col" title="Białko">B</th>
                <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                <th class="text-center nutrient__col"></th>
            </tr>
            <tr v-for="foodPortion in foodPortions">
                <td>
                    {{foodPortion.day.date | format_date}} {{foodPortion.day.date | format_date('dddd') | capitalize}}
                </td>
                <td>
                    {{foodPortion.plan.name}}
                </td>
                <td class="text-center">
                    <input type="number"
                           :min="getPortionAmountMin()"
                           :max="getPortionAmountMax(foodPortion.food)"
                           :step="getPortionAmountStep()"
                           v-bind:value="foodPortion.food.portion.amount"
                           v-on:input="getPortionAmountOnInputListener(foodPortion.food, $event)"
                           v-on:change="getPortionAmountOnChangeListener(foodPortion.food, $event)"
                           class="form-control form-control-xs">
                </td>
                <td class="text-center">
                    {{foodPortion.food.calculateEnergy().amount | round}}
                </td>
                <td class="text-center">
                    {{ foodPortion.food.sumNutrientById(CARBO) | round }}
                </td>
                <td class="text-center">
                    {{ foodPortion.food.sumNutrientById(PROTEIN) | round }}
                </td>
                <td class="text-center">
                    {{ foodPortion.food.sumNutrientById(FATS) | round }}
                </td>
                <td class="text-center">
                    {{ foodPortion.food.sumNutrientById(FIBER) | round }}
                </td>
              <td class="text-center">
                <span title="Usuń porcję" @click="confirmRemovePortion(foodPortion)" role="button" v-if="food.id != foodPortion.food.id">
                                <i class="fa fa-times text-red"></i>
                            </span>
              </td>
            </tr>
            </tbody>
        </table>
        <!-- /.box -->
        <slot name="footer"></slot>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import {productFactory} from '../../factory/product.factory';
    import {multiPortionFoodsManager} from "../../services/MultiPortionFoodsManager";
    import {polishPlurals} from 'polish-plurals';
    import {copyProduct} from "../../services/CopyMenuDay";
    import draggable from 'vuedraggable';
    import {CARBO, FATS, FIBER, PROTEIN, WBT, WW} from "../../services/NutrientDetailsProvider";
    import {trans} from "../../app";
    import {FoodService} from "../../services/FoodService";

    export default {
        props: {
            'food': {
                type: Object,
            },
            'date': {
                type: String,
            },
            'showSaveBtn': {
                type: Boolean,
                default: false,
            },
            mode: {
                type: String,
                default: 'edit',
            },
            'plan': {
                type: Object,
                required: false,
            },
            'day': {
                type: Object,
                required: false,
            },
            'productReplaced': {
                type: Boolean
            },
            'hideReplacing': {
              type: Boolean,
              default: false,
            }
        },
        data() {
            return {
                isLoading: false,
                status: '',
                selected: null,
                foodPortions: [],
                foodNameValid: true,
                foodRecipeValid: true,
                foodHasProducts: true,
                CARBO: CARBO,
                PROTEIN: PROTEIN,
                FATS: FATS,
                FIBER: FIBER,
                WW: WW,
                WBT: WBT,
            };
        },

        created() {
            this.resetSearch(this.$refs.productSelect);
            if (this.food.isMultiPortionFood()) {
                this.foodPortions = this.getFoodPortions(this.food)
            }
        },
        computed: {
            ...mapState({
                schema: state => state.menu.schema,
            }),
            ...mapGetters([
                'configuration',
                'MENU_ID',
                'MENU_MODE',
                'hasPermission',
            ]),
        },
        components: {
          draggable,
        },
        methods: {
            ...mapMutations([
                'checkFoodRepetition',
                'showModal',
            ]),
            polishPlurals(singularNominativ, pluralNominativ, pluralGenitive, value) {
                return polishPlurals(singularNominativ, pluralNominativ, pluralGenitive, value);
            },

            confirmRemove(productId) {
                this.$dialog.confirm('Czy na pewno chcesz usunąć ten składnik?')
                    .then(() => this.remove(productId))
                    .catch(()=>{});
            },
            confirmRemovePortion(portion) {
              this.$dialog.confirm('Czy na pewno chcesz usunąć tę porcję?')
                  .then(() => {
                    const food = portion.food;
                    this.checkFoodRepetition(food);
                    if (food.isMultiPortionFood()) {
                      multiPortionFoodsManager.removeMultiPortionFood(food, this.schema);
                    }
                    portion.plan.removeFood(food.id);
                    this.$root.$emit('multi_portion_food_removed_from_plan', food.isMultiPortionFood());
                    if (this.food.isMultiPortionFood()) {
                      this.foodPortions = this.getFoodPortions(this.food)
                    }
                  })
                  .catch(()=>{});
            },

            checkRepeating() {
                if (this.MENU_MODE) {
                    let endpoint = `/menus/${this.MENU_ID}/food/${this.food.hash}`;

                    if (this.food.date)
                        endpoint += `/${this.food.date}`;

                    axios.get(endpoint).then((r) => this.food.repeating = r.data.dates)
                        .catch((error)=>{
                          this.sentryCaptureException(error);
                        });
                }
            },

            remove(productId) {
                this.checkFoodRepetition(this.food);
                this.food.removeProduct(productId);
                if (this.food.isMultiPortionFood()) {
                    multiPortionFoodsManager.removeProductFromMultiPortionFood(this.food, this.schema, productId);
                }

                this.checkFoodRepetition(this.food);
                this.checkRepeating();
            },

            displayProduct(productDTO) {
                if (!productDTO)
                    return;

                this.selected = productFactory.createFromDto(productDTO);
            },

            addProduct(product) {
                this.checkFoodRepetition(this.food);

                this.food.addProduct(copyProduct(product));

                if (this.food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(this.food, this.schema);
                }

                this.checkRepeating();

                this.checkFoodRepetition(this.food);

                this.validateProducts();

                this.resetSearch(this.$refs.productSelect);

                this.selected = product;
            },

            resetSearch(component) {
                if (component)
                    component.reset();
                this.selected = null;
            },

            getPortionsMin(food) {
                if (food.isMultiPortionFood() && this.mode === 'edit') {

                    const min = multiPortionFoodsManager.getUsedPortionsOfFood(food, this.schema);
                    return min < 2 ? 2 : Math.ceil(min);
                }

                if (this.mode === 'create') {
                    return food.isMultiPortionFood() ? food.portion.amount : 1;
                }

                return 0.1;
            },

            getPortionsStep(food) {
                return food.isMultiPortionFood() || this.mode === 'create' ? 1 : 0.1;
            },

            getPortionsBind(food) {
                if (food.isMultiPortionFood() || this.mode === 'create') {
                    return food.portions;
                }

                return food.portion.amount;
            },

            getPortionsOnInputListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);

                if (this.mode === 'create' || food.isMultiPortionFood()) {
                    food.portions = inputValue < minValue ? minValue : inputValue;
                    if (food.isMultiPortionFood() && this.mode === 'create') {
                        food.portion.amount = Math.ceil(food.portion.amount);
                    }
                    if (food.isMultiPortionFood()) {
                        food.portions = Math.ceil(food.portions);
                        multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                    }
                } else {
                    food.portion.amount = inputValue < minValue ? minValue : inputValue;
                }
            },

            getPortionsOnChangeListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);

                $event.target.value = inputValue < minValue ? minValue : inputValue;

                if (food.isMultiPortionFood() && inputValue < minValue && this.mode !== 'create') {
                    this.$toasted.global.info({message: 'Nie można zmiejszyć liczby porcji przez wykorzystane porcje'});
                }
            },

            getFoodPortions(food) {
                return multiPortionFoodsManager.getPortionsOfFood(food, this.schema);
            },

            getFoodNameOnInputListener(food, $event) {
                food.name = $event.target.value;
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
                this.validateName();
            },

            getFoodRecipeOnInputListener(food, $event) {
                food.recipe = $event.target.value;

                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
                this.validateRecipe();
            },

            getFoodTagsOnChangeListener(food) {
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
            },

            getFoodDietsOnChangeListener(food) {
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
            },

            getFoodMealsOnChangeListener(food) {
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
            },

            getFoodEquipmentsOnChangeListener(food) {
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
            },

            getFoodProductPortionAmountListener(product, food) {
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
            },

            getFoodProductPortionWeightListener(product, food) {
                if (food.isMultiPortionFood()) {
                    multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
                }
            },

            getPortionAmountOnInputListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    food.portion.amount = inputValue;
                } else if (inputValue < minValue) {
                    food.portion.amount = minValue;
                } else if (inputValue > maxValue) {
                    food.portion.amount = maxValue;
                }

                multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
            },

            getPortionAmountOnChangeListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    $event.target.value = inputValue;
                } else if (inputValue < minValue) {
                    $event.target.value = $event.target.min
                } else if (inputValue > maxValue) {
                    $event.target.value = $event.target.max;
                }
            },

            getPortionAmountMax(food) {
                return multiPortionFoodsManager.getLeftPortionsOfFood(food, this.schema) + food.portion.amount;
            },

            getPortionAmountMin() {
                return 0.5;
            },

            getPortionAmountStep() {
                return 0.5;
            },

            validateName() {
                this.foodNameValid = this.food.name !== null && this.food.name.trim().length > 0;
            },
            validateRecipe() {
                this.foodRecipeValid = this.food.recipe !== null && this.food.recipe.trim().length > 0;
            },
            validateProducts() {
                this.foodHasProducts = this.food.products.length > 0;
            },

            validateFood() {
                this.validateName();
                this.validateRecipe();
                this.validateProducts();
            },

            async storeOrUpdate(update = false) {
                this.validateFood();
                if (!this.food.isValid()) {
                    return;
                }

                this.isLoading = true;

                try {
                    let portions;
                    if (this.food.isMultiPortionFood()) {
                        portions = multiPortionFoodsManager.getPortionsOfFood(this.food, this.schema, true)
                            .map(portion => {
                                return portion.food;
                            }).filter(portionFood => {
                                return portionFood.id !== this.id;
                            });
                    }

                    if (update) {
                      this.food = await FoodService.updateFood(this.food);
                    } else {
                      this.food = await FoodService.storeFood(this.food);
                    }

                    this.status = true;

                    if (this.food.isMultiPortionFood()) {
                        portions.forEach(portionFood => {
                            portionFood.externalId = this.food.externalId;
                        });
                    }

                    this.$toasted.global.success({message: 'Danie zostało zapisane'});
                } catch (error) {
                    this.status = false
                    if (error.response && error.response.status === 409) {
                        if (error.response.data.food_uuids.length === 1) {
                          this.$dialog.confirm(trans('app.food_already_exists_in_database_update'))
                              .then(() => {
                                this.food.externalId = error.response.data.food_uuids[0];
                                this.storeOrUpdate(true)
                              })
                              .catch(()=>{
                                this.status = '';
                              })
                        } else {
                          this.$toasted.global.info({message: trans('app.food_already_exists_in_database') });
                        }
                    } else {
                        this.$toasted.global.error({message: 'Danie nie zostało zapisane'});
                        this.sentryCaptureException(error);
                    }
                }

                this.isLoading = false;
            },

          replaceProduct(product) {
            this.showModal({
              component: 'replace-search-product-modal',
              data: {
                productToReplace: product,
                food: this.food,
                plan: this.plan,
                day: this.day
              },
            });
          }

        },
    };
</script>

<style scoped>
.number__select input {
  max-width: 65px;
}

.form-control-xs[type=number] {
  width: 65px;
}

.food__edit__header {
  margin: 10px 0;
}

.black {
  color: #000;
}
.food_product_drag_icon:hover {
  cursor: grab;
}
</style>
